import { connectRefundPolicy } from './connectRefundPolicy';
import { RefundPolicy } from './RefundPolicy';

export const ConnectedRefundPolicy = connectRefundPolicy(RefundPolicy);
